<template>
    <div class="inc_right">
        <template v-if="sideright.content != 'Not Data'">
            <div class="tchtopinf">
                <div class="tchimg">
                    <img :src="'/filestore'+filepath" @error="handleImgError" :alt="title + '教授照片'">
                </div>
            <div class="tchintrd">
                <div class="tchintrd_st">{{ job }}</div>
                <div class="tchintrd_h1">{{ title }}</div>
                <div class="tchintrd_intro" >
                    <div class="tchintrd_phone" v-if="phone != '' && now_special.phone != ''">{{now_special.phone + '：' + phone }}</div>
                    
                    <div class="tchintrd_mark" v-if="fax != '' && now_special.fax != ''">{{ now_special.fax +'：' + fax }}</div>
                    <div class="tchintrd_email" v-if="email != '' && now_special.email != ''">{{now_special.email + '：' + email }}</div>
                </div>
            </div>
            </div>
            <div class="tchintrall">
                <div class="tchtrablock" v-if="research.length >0">
                    <div class="tchbk_title">{{now_special.research }}</div>
                    <div class="tchbk_txtall">
                        <div class="tchbk_txt" v-for="(item,index) in research" v-bind:key="index">
                            {{item}}
                        </div>
                    </div>
                </div>
                <div class="tchtrablock" v-if="offered.length >0">
                    <div class="tchbk_title">{{ now_special.offered }}</div>
                    <div class="tchbk_txtall">
                        <div class="tchbk_txt" v-for="(item,index) in offered" v-bind:key="index">
                            {{item}}
                        </div>
                    </div>
                </div>
                <div class="tchtrablock" v-if="(now_special.PJ_ID != 'PJ20250503' && now_special.PJ_ID != 'PJ20250506') && educational.length >0">
                    <div class="tchbk_title">{{ now_special.educational }}</div>
                    <div class="tchbk_txtall">
                        <div class="tchbk_txt50" v-for="(item,index) in educational" v-bind:key="index">
                            {{item}}
                        </div>
                    </div>
                </div>
                <div class="tchtrablock" v-if="service.length >0">
                    <div class="tchbk_title">{{ now_special.service }}</div>
                    <div class="tchbk_txtall">
                        <div class="tchbk_txt50" v-for="(item,index) in service" v-bind:key="index">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="tchtopinf">
                <div class="tchimg">
                    <img src="/images/therpc_01.jpg"  :alt="title + '教授照片'">
                </div>
                <div class="tchintrd">
                    <div class="tchintrd_st"></div>
                    <div class="tchintrd_h1">Not Data.</div>
                </div>
            </div>
            <div class="tchintrall">
            </div>
        </template>
    </div>
</template>
<script>
export default {
    components:{
        
    },
    data(){
        return{
            //上架時間
            onlineDate:"",
            //上架位置
            onlinePlace:"",
            //文章標題
            title:"",
            //文章內容
            content:"",
            //附件下載清單
            fileData:[],
            //是否使用標籤
            useTag:true,
            //上方次類別
            sublist:{},
            
            filepath:"/",
            job:"",
            phone:"",
            fax:"",
            email:"",
            research:[],
            offered:[],
            educational:[],
            service:[],
            special_list: [
                {
                    //專任教授
                    PJ_ID: "PJ20250501",
                    phone: "Phone",
                    fax: "Fax",
                    email: "E-mail",
                    research: "Research",
                    offered: "Courses Offered",
                    educational:"Educational Background",
                    service:"Research Lab",
                },
                {
                    //兼任教授
                    PJ_ID: "PJ20250502",
                    phone: "",
                    fax: "",
                    email: "E-mail",
                    research:"Research",
                    offered:"Courses Offered",
                    educational:"Current Position",
                    service:"Professional Experience",
                },
                {
                    //退休教授
                    PJ_ID: "PJ20250503",
                    phone: "",
                    fax: "Retired",
                    email: "",
                    research:"Research",
                    offered:"Courses Offered",
                    educational:"",
                    service:"Professional Experience",
                },
                {
                    //行政人員
                    PJ_ID: "PJ20250504",
                    phone: "Phone",
                    fax: "",
                    email: "E-mail",
                    research:"Research",
                    offered:"Courses Offered",
                    educational:"Educational Background",
                    service:"Service",
                },
                {
                    //名譽教授
                    PJ_ID: "PJ20250506",
                    phone: "",
                    fax: "Retired",
                    email: "",
                    research:"Research",
                    offered:"Courses Offered",
                    educational:"",
                    service:"Professional Experience",
                },
            ],
            //當前樣式顯示
            now_special: {},
        };
    },
    props:["sideright","PJ_ID"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "sideright"(){
            this.init();
        },
    },
    methods:{
        init(){
            this.now_special = this.special_list.find(item => item.PJ_ID == this.PJ_ID)|| {
                phone: 'phone',
                fax: 'fax',
                email: 'email',
                research: "research",
                offered: "offered",
                educational: "educational",
                service: "service",
            };
            this.title=this.sideright.title;
            this.filepath = this.sideright.filepath;
            if(this.sideright.content != "Not Data"){
                let json_Data = JSON.parse(this.sideright.content);
                this.job = json_Data.job || "";
                this.phone = json_Data.phone || "";
                this.fax = json_Data.fax || "";
                this.email = json_Data.email || "";
                this.research = Array.isArray(json_Data.research)? json_Data.research :[];
                this.offered = Array.isArray(json_Data.offered)?json_Data.offered:[];
                this.educational = Array.isArray(json_Data.educational)?json_Data.educational:[];
                this.service = Array.isArray(json_Data.service)?json_Data.service:[];
            }else   {
                this.job =  "";
                this.phone = "";
                this.fax = "";
                this.email ="";
                this.research =[];
                this.offered = [];
                this.educational = [];
                this.service = [];
            }
        },
        //若圖片載入失敗時，切換為簡易
        handleImgError(event){
            const img = event.target;
            const fallbackUrl = new URL(
                "/images/therpc_01.jpg",
                window.location.origin
            ).href;

            // 預設圖片也載入失敗時，不再重複設定，避免循環
            if (img.src === fallbackUrl) return;

            img.src = fallbackUrl;
        },
    }
}
</script>